export function getProblemTypeHierarchyChain(tree, problemTypeId) {
	const result = [];

	function findNode(node, targetId) {
		if (node.id === targetId) {
			result.push(node.id);
			return true;
		}

		if (node.children) {
			for (let child of node.children) {
				if (findNode(child, targetId)) {
					result.push(node.id);
					return true;
				}
			}
		}
		return false;
	}

	for (let root of tree) {
		if (findNode(root, problemTypeId)) {
			return result.reverse();
		}
	}
	return [];
}
